import Vue from "vue";
import Vuex from "vuex";

import actions from "./main/actions";
import auth from "./modules/auth";
import book from "./modules/book";
import charts from "./modules/charts";
import createObject from "./modules/create-object";
import commonData from "./modules/common-data";
import dsManager from "./modules/ds-manager";
import interfaceModules from "./modules/interface";
import getters from "./main/getters";
import map from "./modules/map";
import modalWindow from "./modules/modal-window";
import modelling from "./modules/modelling";
import permissions from "./modules/permissions";
import mutations from "./main/mutations";
import profiles from "./modules/profiles";
import proposal from "./modules/proposal";
import state from "./main/state";
import userRoles from "./modules/user-roles";
import trafficCount from "./modules/traffic-count";
import publicTransport from "./modules/public-transport";
import scenarioModelling from "./modules/scenario-modelling";
import eventEditor from "./modules/event-editor";
import smartObjectInfo from "./modules/smart-object-info";
import userTasks from "./modules/user-tasks";
import situationCenter from "./modules/situation-center";
import calculations from "./modules/calculations";

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  getters,
  mutations,
  modules: {
    interface: interfaceModules,
    auth,
    book,
    charts,
    createObject,
    commonData,
    dsManager,
    map,
    modalWindow,
    modelling,
    permissions,
    profiles,
    proposal,
    userRoles,
    trafficCount,
    publicTransport,
    scenarioModelling,
    eventEditor,
    smartObjectInfo,
    userTasks,
    situationCenter,
    calculations
  },
  state
});
